import React, { useEffect, useState } from 'react';

function Hero() {
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setLoaded(true);
    }, 500);

    return () => clearTimeout(timer);
  }, []);

  return (
    <section className='relative text-center overflow-hidden'>

      {/* SEO-only H1 for Google */}
      <h1 className="sr-only">VBM Construction</h1>

      <img
        src='hero4.jpg'
        alt='Construction Restoration'
        className='w-full h-[32rem] md:h-[48rem] object-cover object-top '
      />

      <div className='absolute inset-0 flex flex-col justify-center items-center bg-black bg-opacity-50 p-6 md:p-12'>
        <div className='text-white text-4xl md:text-6xl font-bold flex flex-col items-center space-y-4 md:space-y-6'>
          <span className='animate-word text-6xl md:text-8xl'>Restore</span>
          <span className='animate-word text-6xl md:text-8xl'>Renew</span>
          <span className='animate-word text-6xl md:text-8xl'>Reimagine</span>
        </div>
      </div>
    </section>
  );
}

export default Hero;

    // <div>
    //   <div class='flex justify-end'>
    //     <img
    //       class='object-contain h-1/2 w-2/3 max-w-full max-h-full'
    //       src='https://proest.com/wp-content/uploads/2022/11/Building-Construction-Process-From-Start-To-Finish.jpg'
    //       alt='city background'
    //     />
    //   </div>
    //   {/* <div
    //     className={`absolute inset-0 flex flex-col items-start ml-16 justify-center text-[#2b2b2b] italic font-large text-center overflow-hidden ${
    //       loaded
    //         ? 'translate-x-0 transition-transform duration-1000 ease-out'
    //         : '-translate-x-full'
    //     }`}
    //   >
    //     <span className='text-7xl  mb-4 font-CelebesThin'>Restore</span>
    //     <span className='text-7xl ml-8 mb-4 font-CelebesThin '>Renew</span>
    //     <span className='text-7xl ml-16 font-CelebesThin'>Reimagine</span>
    //   </div> */}
    // </div>
